import React from 'react';
import SegmentedControl from '@amzn/awsui-components-core/segmented-control';
import Select from '@amzn/awsui-components-core/select';
import SpaceBetween from '@amzn/awsui-components-core/space-between';

type DataMode = 'live' | 'snapshot';

interface DataModeSelectorProps {
  mode: DataMode;
  onModeChange: (mode: DataMode) => void;
  /** Omit the week props to render the Live/Snapshot toggle alone (no week dropdown). */
  selectedWeek?: string | null;
  availableWeeks?: string[];
  onWeekChange?: (week: string) => void;
}

const DataModeSelector: React.FC<DataModeSelectorProps> = ({
  mode,
  selectedWeek,
  availableWeeks,
  onModeChange,
  onWeekChange,
}) => {
  const weekOptions = (availableWeeks ?? [])
    .filter((w): w is string => Boolean(w))
    .map((w) => ({ label: w, value: w }));

  return (
    <SpaceBetween direction="horizontal" size="s">
      <SegmentedControl
        selectedId={mode}
        onChange={({ detail }) => onModeChange(detail.selectedId as DataMode)}
        label="Data source"
        options={[
          { text: 'Live', id: 'live' },
          { text: 'Snapshot', id: 'snapshot' },
        ]}
      />
      {availableWeeks && onWeekChange && (
        <div className="data-mode-selector__week">
          <Select
            selectedOption={
              weekOptions.find((o) => o.value === selectedWeek)
              ?? weekOptions[weekOptions.length - 1]
              ?? { label: '', value: '' }
            }
            onChange={({ detail }) => onWeekChange(detail.selectedOption.value!)}
            options={weekOptions}
          />
        </div>
      )}
    </SpaceBetween>
  );
};

export default DataModeSelector;
